import NewHeader from "../components/NewHeader_dev";
import ProductCSS from "./Product_dev2.module.css";
import Product_dev2 from "../components/product_dev2";
import Footer from "../components/Footer";

function Product() {
  return (
    <div className={ProductCSS.content}>
      <NewHeader />
      <Product_dev2 />
      <br />
            <br />          
            <Footer />          
    </div>
  );
}
export default Product;
